const LOGO_SRC = "/logo.png";

export const Logo = ({ className = "h-10 w-auto", alt = "Web Builders logo" }) => (
  <img
    src={LOGO_SRC}
    alt={alt}
    className={`${className} mix-blend-screen`}
    draggable="false"
  />
);

export default Logo;
